import { ProductDetails, ApplicationSM3Result, ProductDetailsCommon } from './application-form.model';
import { DipModel } from './dip.model';
import { Product } from './product-selector.model';
import { Helper } from '../utitlity/helper';
import { constants } from '../utitlity/constant';

export class ApplicationModel {
    _customerInfo: any;
    productDetails: ProductDetails[];
    smg3Response: any;
    _submitResponse: DipModel;
    accountSetup: AccountSetup;
    accountCreditCardDetails: AccountCreditCardDetails;
    isRiskCallFailed: string;
    isSaveIndv: boolean;
    _channelId: string;
    dipTandC: TermsAndCondition;
    primaryProduct: Product = new Product();
    secondaryProduct: Product = new Product();
    overdraft: ProductDetails = new ProductDetails();
    productDetailCommon: ProductDetailsCommon = new ProductDetailsCommon();
    eligibilityDetails: any = {};
    _productList: any = {};
    reinstatePreApprovedFlag: string;
    taxInfo: any;
    rosInfo: any;
    signature: SignatureModel;
    isRetrieve: boolean;
    cashbackApply: boolean;

    get channelId(){
        return this._channelId
    }

    set channelId(channelId){
        this._channelId = channelId;
    }
    set marketSectorCode(code){
        this.productDetailCommon.marketSectorCd = code;
    }
    get marketSectorCode(){
        return this.productDetailCommon.marketSectorCd;
    }

    get isMultiProductJourney(){
        return (this.primaryProduct && this.primaryProduct.pCode
                 && this.secondaryProduct && this.secondaryProduct.pCode)
    }

    get isCardOnlyProduct(){
        return (this.primaryProduct && this.primaryProduct.categories == 'Accounts') 
        && !this.secondaryProduct;
    }

    get staffId() {
        return this.productDetailCommon.staffId;
    }
    set staffId(staffId){
        this.productDetailCommon.staffId = staffId;
    }

    get isCardOnlyJourney(){
        return this.isCardOnlyProduct;
    }

     set appRefNumber(arn){
        this.productDetailCommon.arnRef = arn;
    }
     get appRefNumber(){
        return this.productDetailCommon.arnRef;
    }

    get arnStageCode(){
        return this.productDetailCommon.arnStageCd;
    }

    get arnStageCodeAlias(){
        let result;
            if(this.productDetailCommon && this.productDetailCommon.arnStageCd){
                result = constants.stageCodes[this.productDetailCommon.arnStageCd];
            };
            return result;
    }

    isErrorModule(){
        let isReinstated = this.reinstatePreApprovedFlag && this.reinstatePreApprovedFlag.toLowerCase() == 'y';
        let isRiskCallFailed = this.isRiskCallFailed && this.isRiskCallFailed.toLowerCase() == 'y';
        return !!(isRiskCallFailed || isReinstated);
    }

    set productList(products){
        
    }

    get productList(){
        if(this._productList && Object.keys(this._productList).length == 0){
            this._productList.primaryProduct = this.primaryProduct;
            this._productList.secondaryProduct = this.secondaryProduct;
            this._productList.overdraft = this.overdraft;
        }
        return this._productList;
    }



    setProducts() {
        if (this.productDetails && this.productDetails.length) {
            for (let i = 0; i < this.productDetails.length; i++) {
                let product: ProductDetails = this.productDetails[i];
                if(product){
                    if(product.productPriority == 1){
                        this._productList.primaryProduct = product;
                    } else
                    if(product.productPriority == 2){
                        this._productList.secondaryProduct = product;
                    } else
                    if(product.productPriority == 3){
                        this._productList.overdraft = product;
                    }
                }
            }
        }
    }

    set submitResponse(response: any){
        this._submitResponse =  new DipModel(response);
        // this.accountSetup = new AccountSetup(response.accountSetup);
        this.accountCreditCardDetails = new AccountCreditCardDetails(this.formAccCcDetailsObj());
        // this.dipTandC = new TermsAndCondition(response.dipTandC);
    }

    get submitResponse(){
        return this._submitResponse;
    }
    set customerInfo(customerData){
        let rosInfo;
        let custData;
        let taxInfo;
        if(customerData){
            rosInfo = this.rosInfo;
            delete customerData.rosInfo;
            if(rosInfo){
                taxInfo = rosInfo.taxInfo;
                delete rosInfo.taxInfo;
            }
            custData = {...customerData,...rosInfo};
            this.taxInfo = taxInfo;
            this._customerInfo = custData;
        }

    }


    get customerInfo(){
        return this._customerInfo;
    }

    formAccCcDetailsObj() {
        let obj: object = {};
        // Helper.applicationObj.journeyType = "account";
        let acceptedOD = this.submitResponse.acceptedOD();
        let refferedOD = this.submitResponse.refferedOD();
        let refferedCard = this.submitResponse.refferedCard();
        let acceptedCard = this.submitResponse.acceptedCard();

        obj["actualAccountNumber"] = this.submitResponse && this.submitResponse.actualAccountNumber;
        obj["ccLimit"] = (refferedCard && refferedCard.userLimit) || (acceptedCard && acceptedCard.userLimit);
        obj["overdraftLimit"] = (refferedOD && refferedOD.userLimit) || (acceptedOD && acceptedOD.userLimit);
        obj["overdraftIntRate"] = (refferedOD && refferedOD.interestRate + "% p.a. on balance over interest free limit") || (acceptedOD && acceptedOD.interestRate + "% p.a. on balance over interest free limit");
        obj["refNumber"] = this.appRefNumber;

        if(this.primaryProduct && this.secondaryProduct) {
            if (Helper.applicationObj.journeyType == constants.PRODUCT_ACCOUNT) {
                obj["sccBelowBalFee"] = this.primaryProduct.accountBelowBalanceFees;
                obj["interestFreeLimit"] = this.primaryProduct.interestFreeLimit;
                obj["ccIntRate"] = this.secondaryProduct.interestRate + 'p.m.';
                obj["ccFeesAndCharges"] = this.secondaryProduct.feesAndCharges;
            } else if (Helper.applicationObj.journeyType == constants.PRODUCT_CARD) {
                obj["sccBelowBalFee"] = this.secondaryProduct.accountBelowBalanceFees;
                obj["interestFreeLimit"] = this.secondaryProduct.interestFreeLimit;
                obj["ccIntRate"] = this.primaryProduct.interestRate + 'p.m.';
                obj["ccFeesAndCharges"] = this.primaryProduct.feesAndCharges;
            }
        }

        return obj;
    }
    
    constructor(retrieveResp?) {
        if (retrieveResp) {
            this.customerInfo = retrieveResp.customerInfo;
            if (retrieveResp.productDetails) {
                this.productDetails = retrieveResp.productDetails.map(product => {
                    return new ProductDetails(product);
                });
                this.setProducts();
            }
            if (retrieveResp.sl4ContinueResp) {
                this.smg3Response = retrieveResp.sl4ContinueResp.response;
            }
            if (retrieveResp.submitAppResp) {
                this.submitResponse = retrieveResp.submitAppResp.response;
                // this.accountCreditCardDetails = new AccountCreditCardDetails(this.formAccCcDetailsObj());
                //this.dipTandC = new TermsAndCondition(retrieveResp.dipTandC);
            }
            if(retrieveResp && retrieveResp.signatureDetails){
                this.signature = new SignatureModel(retrieveResp.signatureDetails);
            }
            this.accountSetup = new AccountSetup(retrieveResp.accountSetup);
            this.dipTandC = new TermsAndCondition(retrieveResp.dipTandC);
            this.isRiskCallFailed = retrieveResp.isRiskCallFailed;
            this.isSaveIndv = retrieveResp.isSaveIndv;
            this.channelId = retrieveResp.eligibilityDetails ? retrieveResp.eligibilityDetails.channelId : '';            
            this.productDetailCommon = new ProductDetailsCommon(retrieveResp.productDetailsCommon);
            this.eligibilityDetails = retrieveResp.eligibilityDetails || {};
            this.reinstatePreApprovedFlag = retrieveResp.reinstatePreApprovedFlag;
        }
    }

}

export class AccountSetup {
    custName: string = "";
    cardPaymentDate: any;
    channelOfCommunication: Array<string> = ["Email", "Phone", "SMS"];
    outStanding: string = "0";
    isChequeBookOpt: string = "";
    collectionOption: string = "";
    jadeId: string = "";
    jadeRelation: any;
    statusCode: string = "";
    arnRef: string = "";

    constructor(accountSetup?) {
        if(accountSetup) {
            this.custName = accountSetup.custName;
            this.cardPaymentDate = accountSetup.cardPaymentDate;
            this.channelOfCommunication = accountSetup.channelOfCommunication;
            this.outStanding = accountSetup.outStanding;
            this.isChequeBookOpt = accountSetup.isChequeBookOpt;
            this.collectionOption = accountSetup.collectionOption;
            this.jadeId = accountSetup.jadeId;
            this.jadeRelation = accountSetup.jadeRelation;
            this.statusCode = accountSetup.statusCode;
            this.arnRef = accountSetup.arnRef;
        }
    }
}

export class TermsAndCondition {
    firstProductInfo: Array<TnCProductDetails> = [];
    secondProductInfo: Array<TnCProductDetails> = [];
    odProductInfo: Array<TnCProductDetails> = [];
    checkBox: boolean = false;
    staffId: string = "";

    constructor(tandc?) {
        if(tandc){
        if(tandc.firstProductInfo) {
            this.firstProductInfo = tandc.firstProductInfo.map(product => {
                return new TnCProductDetails(product);
            });
        }
        if(tandc.secondProductInfo) {
            this.secondProductInfo = tandc.secondProductInfo.map(product => {
                return new TnCProductDetails(product);
            })
        }
        if(tandc.odProductInfo) {
            this.odProductInfo = tandc.odProductInfo.map(product => {
                return new TnCProductDetails(product);
            })
        }
        this.checkBox = tandc.checkBox;
        this.staffId = tandc.staffId;
    }
    }
}


export class TnCProductDetails {
    pdfUrl: string = "";
    name: string = "";
    version: string = "";
    tAndCSeq: any;
    timestamp: string = "";
    acceptence: string = "";
    productCode: string = "";

    constructor(product?) {
        if(product) {
            this.pdfUrl = product.pdfUrl;
            this.name = product.name;
            this.version = product.version;
            this.tAndCSeq = product.tAndCSeq;
            this.timestamp = product.timestamp;
            this.acceptence = product.acceptence;
            this.productCode = product.productCode;    
        }
    }
}

export class AccountCreditCardDetails {
    actualAccountNumber: string = "";
    sccBelowBalFee: string = "";
    overdraftLimit: number;
    interestFreeLimit: string;
    overdraftIntRate: string;
    ccLimit: number;
    ccFeesAndCharges: string = "";
    ccIntRate: string = "";
    refNumber: string = "";

    constructor(data?) {
        if(data) {
            this.actualAccountNumber = data.actualAccountNumber;
            this.sccBelowBalFee = data.sccBelowBalFee;
            this.overdraftLimit = data.overdraftLimit;
            this.interestFreeLimit = data.interestFreeLimit;
            this.overdraftIntRate = data.overdraftIntRate;
            this.ccLimit = data.ccLimit;
            this.ccFeesAndCharges = data.ccFeesAndCharges;
            this.ccIntRate = data.ccIntRate;
            this.refNumber = data.refNumber;    
        }
    }
}


export class SignatureModel{
    private _signature: string;
    isSignatureCaptured: boolean;

    get signature(){
        return  'data:image/png;base64,'+this._signature
    }
    set signature(sign){
        this._signature = sign;
    }
    constructor(signatureDetails?){
        if(signatureDetails){
            this.signature = signatureDetails.signatureImageStr
        }
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/lodash/lodash.js!./~/tslint-loader!./src/app/models/application.model.ts